import Vue from 'vue';

import qrCode from 'qrcode.vue';
import SdoLoader from '@/components/Global/SdoLoader.vue';
import BackButton from '@/components/Global/BackButton.vue';
import DeleteDialog from '@/components/Global/DeleteDialog.vue';
import ConfirmDialog from '@/components/Global/ConfirmDialog.vue';
import PermissionsWrapper from '@/components/Global/PermissionsWrapper.vue';
import ServerData from '@/components/Global/ServerData.vue';
import ServerDataWrapper from '@/components/Global/ServerDataWrapper.vue';
import VAutocompleteMore from '@/components/Global/VAutocompleteMore.vue';
import DisabledWrap from '@/components/Global/DisabledWrap.vue';
import CopyClipboardField from '@/components/Global/CopyClipboardField.vue';
import DataWrapper from '@/components/Global/DataWrapper.vue';
import ApiForm from './ApiForm.vue';
import TooltipWrap from './TooltipWrap.vue';
import SdoDatetimeField from './SdoDatetimeField.vue';
import LazyLoad from './LazyLoad.vue';
import EvChip from './EvChip.vue';

// Для динамического импорта можно регистрировать компоненты
// таким способом, но это ломает автокомплит:
// Vue.component('sdo-back-button', () => import('./BackButton')); // Кнопка "< Назад"

Vue.component('sdo-loader', SdoLoader);
Vue.component('sdo-back-button', BackButton);
Vue.component('delete-dialog', DeleteDialog);
Vue.component('confirm-dialog', ConfirmDialog);
Vue.component('permissions-wrapper', PermissionsWrapper);
Vue.component('server-data', ServerData);
Vue.component('v-autocomplete-more', VAutocompleteMore);
Vue.component('disabled-wrap', DisabledWrap);
Vue.component('copy-clipboard-field', CopyClipboardField);
Vue.component('api-form', ApiForm);
Vue.component('tooltip-wrap', TooltipWrap);
Vue.component('sdo-datetime-field', SdoDatetimeField);
Vue.component('lazy-load', LazyLoad);
Vue.component('ev-chip', EvChip);
Vue.component('QrCode', qrCode);
Vue.component('data-wrapper', DataWrapper);
Vue.component('server-data-wrapper', ServerDataWrapper);
